import React, { useCallback, useEffect, useMemo, useState } from "react";
import companyService from "../../company/services/companyApi"
import useCompany from "../../company/hooks/useCompany";
import session from "utils/session";
import * as adminService from "../services/adminApi"
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setIsLogin, setProfile } from "../../authentication/slices/loginSlice";
import useLogin from "features/authentication/hooks/useLogin";
import { setCompanyInfo, setCompanyList, setIsLoading, setUserAdminList } from "../slices/adminCompanySlice";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";

function useAdminCompany() {
    const { t, i18n } = useTranslation();
    const { getCompanyOptions = () => { } } = useCompany();
    const { doLoginForAdminAccess = () => { } } = useLogin();
    const navigate = useNavigate()
    const dispatch = useDispatch();
    const [pagination, setPagination] = useState();
    const { currentCompany, currentEmployee } = useSelector((state) => state.company)
    const { companyList, isLoading, userAdminList } = useSelector((state) => state.adminCompany)
    const [search, setSearch] = useState({});

    // const doLoginForAdminAccess = useCallback(
    //     async (values) => {
    //         try {
    //             dispatch(setIsLoading(true));
    //             dispatch(setIsLogin(false));
    //             const modifyValues = {
    //                 username: values.email,
    //                 password: values.password,
    //             };
    //             const response = await loginByAdmin(modifyValues);
    //             const token = response.data?.token || null;
    //             session.setAuthToken(token);
    //             if (values.rememberMe === "Y") {
    //                 window.localStorage.setItem("rememberUser", values.email);
    //             }
    //             dispatch(setProfile(response.data));
    //             dispatch(setIsLogin(true));
    //             // alert({ message: "Login successful." });
    //             navigate("/");
    //         } catch (error) {
    //             alert({
    //                 type: "error",
    //                 message: "Login failed!!!",
    //                 resultObject: error,
    //             });
    //         } finally {
    //             dispatch(setIsLoading(false));
    //         }
    //     },
    //     [dispatch, navigate]
    // );

    const onSelectCompany = useCallback(async (companyId) => {
        try {
            dispatch(setIsLogin(true));
            const response = await adminService.getCompanyInformationForAdmin({
                companyId: companyId
            })
            dispatch(setCompanyInfo(response.data?.content))
        } catch (error) {

        } finally {
            dispatch(setIsLogin(false));
        }
    }, [dispatch])

    const onAccessCompany = useCallback(async (companyId) => {
        try {
            const response = await adminService.adminAccessCompany({
                companyId: companyId
            })

            dispatch(setProfile(response.data));
            const token = response.data?.token || null;
            session.setAuthToken(token);
            // if (values.rememberMe === "Y") {
            //     window.localStorage.setItem("rememberUser", response.data?.email);
            // }
            dispatch(setIsLogin(true));
        } catch (error) {

        }
    }, [])

    const getAdminComapnyPagination = useCallback(async (params, pagination) => {
        dispatch(setIsLoading(true))
        await adminService.getCompanyPaginationForAdmin({
            ...params,
            page: params.page,
            size: params.size
        }).then((response) => {
            dispatch(setCompanyList(response?.data?.page?.content || []))
            setPagination({
                current: response?.data?.page?.number + 1,
                total: response?.data?.page?.totalElements,
                size: response?.data?.page?.size
            });
        }).catch((error) => {
            // Alert({ type: "error", resultObject: error })
        }).finally(() => {
            dispatch(setIsLoading(false))
        })
    }, [currentCompany, currentEmployee])

    const getDropdownUserAdmin = useCallback(async () => {
        dispatch(setIsLoading(true))
        await adminService.dropdownUserAdmin({
            // ...params,
            // companyId: currentCompany,
            // employeeId: currentEmployee
        }).then((res) => {
            dispatch(setUserAdminList(res?.data?.content || []))
        }).catch((error) => {

        }).finally((o) => {

            dispatch(setIsLoading(false))
        })
    }, [dispatch])

    const userAdminListOptions = useMemo(() => {
        return userAdminList?.map((o) => {
            return {
                ...o,
                // label: i18n.language === 'en' ? o?.fullNameEn : o?.fullName,
                label: o?.username,
                value: o?.id
            }
        })
    }, [userAdminList, i18n.language])

    const handleSearch = (values) => {
        try {
            const filters = {
                ...values,
                startDate: values?.startDate ? dayjs(values?.startDate)?.format("YYYY-MM-DD") : null,
                endDate: values?.endDate ? dayjs(values?.endDate)?.format("YYYY-MM-DD") : null
            };

            setSearch(filters);
            getAdminComapnyPagination({
                page: 0,
                size: 9,
                ...filters
            })
        } catch (error) { }
    }

    useEffect(() => {
        getDropdownUserAdmin();
    }, [])

    return {
        onAccessCompany,
        onSelectCompany,
        companyList,
        pagination,
        getAdminComapnyPagination,
        isLoading,
        handleSearch,
        userAdminListOptions
    };
};
export default useAdminCompany; 